function formatKey(key) {
  return key.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
}

export function ClassificationDetails({ data, type }) {
  if (!data) return null;

  return (
    <div className="bg-blue-50 px-4 py-3 rounded text-sm text-black mt-2">
      <p className="font-semibold text-[#1E40AF] mb-1">{type} Details</p>
      {Object.entries(data)
        .filter(([_, value]) => value !== null && value !== undefined)
        .map(([key, value]) => (
          <div key={key} className="flex gap-2">
            <div className="font-semibold text-[#1E40AF] mb-1">
              {formatKey(key)}:
            </div>
            <div>{String(value)}</div>
          </div>
        ))}
    </div>
  );
}

export default ClassificationDetails;
